const translations = {
  title: 'New User',
  title_edit: 'Editing User',
  bulkEdit: 'Bulk registration',
  name: 'Name',
  email: 'Email',
  profile: 'Profile',
  groups: 'Groups',
  productiveCapacity: 'Productive capacity',
  relatedUsers: 'Related users',
  fakeEmailQuestion: 'Fake email?',
  fakeEmail: 'Fake email',
  canAccessPaymentModule: 'Can access payment module',
  changingPassword: 'Changing password for {{name}}',
  temporaryPassword: 'Temporary password',
  temporaryPasswordConfirmation: 'Temporary password confirmation',
  passwordRequired: 'Password required',
  minCharacters: 'Minimum of {{count}} characters',
  passwordsDoNotMatch: 'Passwords do not match',
  maxLengthExceeded: 'Maximum length exceeded',
  checkWorkShifts: 'Check work shifts',
  successTitle: 'Registered successfully!',
  successMessage: 'User registered successfully.'
}

export default translations
